import Vue from 'vue';
import VueRouter from 'vue-router';
import { getURLSearchParams } from '@/utils/utils';

Vue.use(VueRouter);

const routes = [
  {
    path: '/enterpriseAuth/apply',
    name: 'enterpriseAuthApply',
    component: () => import(/* webpackChunkName: "enterpriseApply" */ '@/sub-app/enterpriseAuth/pages/apply.vue'),
    meta: {
      title: '员工认证', 
      keepAlive: true,
    },
  },
  {
    path: '/enterpriseAuth/applyResult',
    name: 'enterpriseAuthResult',
    component: () => import(/* webpackChunkName: "enterpriseAuthResult" */ '@/sub-app/enterpriseAuth/pages/applyResult.vue'),
    meta: {
      title: '员工认证', 
      keepAlive: true,
    },
  },
  {
    path: '/enterpriseAuth/authList',
    name: 'enterpriseAuthList',
    component: () => import(/* webpackChunkName: "enterpriseAuthList" */'@/sub-app/enterpriseAuth/pages/authList.vue'),
    meta: {
      title: '员工认证', 
      keepAlive: false,
    },
  },
  {
    path: '/enterpriseAuth/myAuth',
    name: 'enterpriseMyAuth',
    component: () => import(/* webpackChunkName: "enterpriseMyAuth" */'@/sub-app/enterpriseAuth/pages/myAuth.vue'),
    meta: {
      title: '我的审批', 
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  let title = to.meta?.title || '';
  const urlParams = getURLSearchParams();
  if (urlParams && urlParams.title) {
    title = decodeURIComponent(urlParams.title);
  }
  document.title = title;
  document.title = to.meta?.title || '';
  next();
});

export default router;
